import React from "react";


const countOfEmployees=[
    {
        key:'1-20',
        value:1
    }
    ,
    {
        key:'1-30',
        value:2
    }
]

export{
    countOfEmployees
}